
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"500","height":"300"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('use',{attrs:{"id":"f","xlink:href":"#e","x":"250","y":"106"}}),_c('g',{attrs:{"id":"e","fill":"#1eb53a"}},[_c('g',{attrs:{"id":"d"}},[_c('g',{attrs:{"id":"c"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"id":"a","d":"M0-20V0h20","transform":"rotate(30 0 -20)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"scale(-1 1)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(120)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(240)"}})]),_c('use',{attrs:{"xlink:href":"#c","transform":"rotate(180)"}})]),_c('use',{attrs:{"xlink:href":"#d","fill":"#ce1126","transform":"scale(.82)"}})])]),_c('path',{attrs:{"d":"M0 0h500L0 300h500z","fill":"#ce1126"}}),_c('path',{attrs:{"d":"M0 0v300L500 0v300z","fill":"#1eb53a"}}),_c('path',{attrs:{"d":"M0 0l500 300m0-300L0 300","stroke":"#fff","stroke-width":"40"}}),_c('circle',{attrs:{"cx":"250","cy":"150","r":"85","fill":"#fff"}}),_c('use',{attrs:{"xlink:href":"#f"}}),_c('use',{attrs:{"xlink:href":"#f","transform":"rotate(120 250 150)"}}),_c('use',{attrs:{"xlink:href":"#f","transform":"rotate(240 250 150)"}})])
          )
        }
      }
    